// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__753lV","loader":"Preloader_loader__a8Jco"};